import {Button, DatePicker, Divider, Input, Select, Upload} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import {useEffect, useLayoutEffect, useState} from "react";
import config from "@/config";

export const ProfileSection = () => {
    const handleChangeProvince = (provinceCode) => {
        const selected = provinces.find(province => province.value === provinceCode);
        setProvince(selected);
        setDistricts(selected ? selected.districts.map(district => ({
            value: district.code,
            label: district.name,
            wards: district.wards
        })) : []);
        setDistrict(null);
        setWards([]);
    };
    const handleChangeDistrict = (districtCode) => {
        const selected = districts.find(district => district.value === districtCode);
        setDistrict(selected);
        setWards(selected ? selected.wards.map(ward => ({
            value: ward.code,
            label: ward.name
        })) : []);
        setWard(null);
    };


    const [province, setProvince] = useState(null);
    const [district, setDistrict] = useState(null);
    const [ward, setWard] = useState(null);

    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [houseNumber, setHouseNumber] = useState("");

    useLayoutEffect(() => {
        fetch(config.api.provinces)
            .then(res => res.json())
            .then(data => {
                setProvinces(data.map(city => ({
                    value: city.code,
                    label: city.name,
                    districts: city.districts,
                })));
            })
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        if (province) {
            fetch(`${config.api.districts}?provinceCode=${province}`)
                .then(res => res.json())
                .then(data => setDistricts(data.map(d => ({value: d.code, label: d.name}))))
                .catch(err => console.error(err));
        } else {
            setDistricts([]);
            setWards([]);
        }
    }, [province]);

    useEffect(() => {
        if (district) {
            fetch(`${config.api.wards}?districtCode=${district}`)
                .then(res => res.json())
                .then(data => setWards(data.map(w => ({value: w.code, label: w.name}))))
                .catch(err => console.error(err));
        } else {
            setWards([]);
        }
    }, [district]);
    const [cccd, setCCCD] = useState("");
    const [error, setError] = useState("");

    // Validate CCCD (9 hoặc 12 số)
    const handleCCCDChange = (e) => {
        const value = e.target.value;
        setCCCD(value);
        if (!/^\d{9}(\d{3})?$/.test(value)) {
            setError("Nhập đủ 9 hoặc 12 số");
        } else {
            setError("");
        }
    };

    return (
        <>
            <h2 className={"text-2xl font-bold mb-4"}>Thông tin hồ sơ</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Ảnh đại diện */}
                <div className="flex flex-col items-center border-r pr-6">
                    <Upload>
                        <Button icon={<UploadOutlined/>}>Tải ảnh lên</Button>
                    </Upload>
                    <p className="text-gray-500 text-xs mt-2">
                        Đăng hình dưới dạng PNG, JPG, dung lượng không vượt quá 3MB
                    </p>
                </div>

                {/* Form bên phải */}
                <div className="col-span-2 grid grid-cols-2 gap-4">
                    {/* Họ tên */}
                    <div>
                        <label className="font-bold">Họ tên <span className="text-red-500">*</span></label>
                        <Input placeholder="VD: Nguyễn Văn B"/>
                    </div>

                    {/* Ngày sinh */}
                    <div>
                        <label className="font-bold">Ngày sinh <span className="text-red-500">*</span></label>
                        <DatePicker className="w-full" placeholder="mm/dd/yyyy"/>
                    </div>

                    {/* CCCD/CMND */}
                    <div>
                        <label className="font-bold">CCCD/CMND <span className="text-red-500">*</span></label>
                        <Input placeholder="Nhập CMND/CCCD" value={cccd} onChange={handleCCCDChange}/>
                        {error && <p className="text-red-500 text-sm">{error}</p>}
                    </div>

                    {/* Nơi cấp */}
                    <div>
                        <label className="font-bold">Nơi cấp <span className="text-red-500">*</span></label>
                        <Input placeholder="Nơi cấp CMND/CCCD"/>
                    </div>

                    {/* Giới tính */}
                    <div>
                        <label className="font-bold">Giới tính</label>
                        <Select className="w-full" placeholder="Chọn giới tính">
                            <Select.Option value="male">Nam</Select.Option>
                            <Select.Option value="female">Nữ</Select.Option>
                            <Select.Option value="other">Khác</Select.Option>
                        </Select>
                    </div>

                    {/* Dân tộc */}
                    <div>
                        <label className="font-bold">Dân tộc</label>
                        <Input placeholder="Dân tộc"/>
                    </div>

                    {/* Hôn nhân */}
                    <div>
                        <label className="font-bold">Hôn nhân</label>
                        <Input placeholder="Hôn nhân"/>
                    </div>

                    {/* Tôn giáo */}
                    <div>
                        <label className="font-bold">Tôn giáo</label>
                        <Select className="w-full" placeholder="Chọn tôn giáo">
                            <Select.Option value="none">Không</Select.Option>
                            <Select.Option value="buddhism">Phật giáo</Select.Option>
                            <Select.Option value="christianity">Thiên chúa</Select.Option>
                            <Select.Option value="other">Khác</Select.Option>
                        </Select>
                    </div>
                </div>
            </div>
            <Divider className={"my-6"}/>
            <h2 className={"text-2xl font-bold"}>Thông tin liên hệ</h2>
            <div className="grid grid-cols-2 gap-4 p-4 border border-gray-200">
                {/* Điện thoại */}
                <div>
                    <label className="font-bold">Điện thoại <span className="text-red-500">*</span></label>
                    <Input placeholder="VD:0905123456"/>
                </div>

                {/* Email */}
                <div>
                    <label className="font-bold">Email</label>
                    <Input placeholder="VD : Email@gmail.com"/>
                </div>

                {/* Địa chỉ thường trú */}
                <div className={"col-span-2"}>
                    <label className="font-bold">Địa chỉ thường trú<span className={"text-red-500"}>*</span></label>
                </div>
                <Select
                    className="w-full"
                    placeholder="Chọn Tỉnh/Thành"
                    options={provinces}
                    onChange={handleChangeProvince}
                />
                <Select
                    className="w-full"
                    placeholder="Chọn Quận/Huyện"
                    options={districts}
                    onChange={handleChangeDistrict}
                    disabled={!province}
                />
                <Select
                    className="w-full"
                    placeholder="Chọn Xã/Phường"
                    options={wards}
                    onChange={setWard}
                    disabled={!district}
                />
                <Input placeholder="Nhập số nhà, đường" value={houseNumber}
                       onChange={e => setHouseNumber(e.target.value)}/>
            </div>
            <Divider className={"my-6"}/>
            <h2 className={"text-2xl font-bold"}>Trình độ học vấn</h2>
            <div className={"grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border border-gray-200"}>
                {/* Trình độ */}
                <div>
                    <label className="font-bold">Trình độ</label>
                    <Select className={"w-full"} placeholder="Chọn trình độ">
                        <Select.Option value="none">Không</Select.Option>
                        <Select.Option value="primary">Tiểu học</Select.Option>
                        <Select.Option value="secondary">Trung học cơ sở</Select.Option>
                        <Select.Option value="highschool">Trung học phổ thông</Select.Option>
                        <Select.Option value="college">Cao đẳng</Select.Option>
                        <Select.Option value="university">Đại học</Select.Option>
                        <Select.Option value="master">Thạc sĩ</Select.Option>
                        <Select.Option value="doctor">Tiến sĩ</Select.Option>
                    </Select>
                </div>

                {/* Trường */}
                <div>
                    <label className="font-bold">Trường tốt nghiệp</label>
                    <Input placeholder="VD: Đại học Bách Khoa"/>
                </div>

                {/* ngoại ngữ */}
                <div>
                    <label className="font-bold">ngoại ngữ</label>
                    <Select className={"w-full"} placeholder="Chọn ngoại ngữ">
                        <Select.Option value="none">Không</Select.Option>
                        <Select.Option value="english">Tiếng Anh</Select.Option>
                        <Select.Option value="chinese">Tiếng Trung</Select.Option>
                        <Select.Option value="japanese">Tiếng Nhật</Select.Option>
                        <Select.Option value="korean">Tiếng Hàn</Select.Option>
                        <Select.Option value="french">Tiếng Pháp</Select.Option>
                        <Select.Option value="german">Tiếng Đức</Select.Option>
                        <Select.Option value="russian">Tiếng Nga</Select.Option>
                    </Select>
                </div>

                {/* Năm tốt nghiệp */}
                <div className={"col-span-1 md:col-span-2"}>
                    <label className="font-bold">Năm tốt nghiệp</label>
                    <DatePicker className="w-full" placeholder="mm/dd/yyyy"/>
                </div>
                <div className={"col-span-1 md:col-span-2"}>
                    <label className={"font-bold"}>Bằng cấp khác</label>
                    <Input.TextArea placeholder="Nhập bằng cấp khác"/>
                </div>
            </div>
            <div className={"flex flex-col md:flex-row justify-between items-center gap-4 mt-6"}>
                <span className={"text-red-500"}>Những mục có dấu (*) là bắt buộc</span>
                <Button className={"font-bold w-40 h-10"} type={"primary"}>Lưu</Button>
            </div>
        </>
    )
}